import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  lifecycle,
  withHandlers
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Modal from '@material-ui/core/Modal';
import MenuItem from '@material-ui/core/MenuItem';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import InputAdornment from '@material-ui/core/InputAdornment';
import Checkbox from '@material-ui/core/Checkbox';
import { RadioGroup, Radio, Select, ListItem } from '@material-ui/core';
import RequiredButton from '../../components/atoms/RequiredButton';
import AnyButton from '../../components/atoms/AnyButton';
import CancelButton from '../../components/atoms/CancelButton';
import ConfirmButton from '../../components/atoms/ConfirmButton';
import FileUpload from '../../components/molecules/FileUpload';
import GochiMenuEventEditConfirm from './GochiMenuEventEditConfirm';
import {
  getGochiMenusEvent,
  editGochiMenuEvent,
  addGochiMenuEventImage
} from '../../actions/GochiMenusEvent';
import { resizeImage, uploadFile, sendLogin } from '../../auth/Auth';
import ValidationText from '../../components/atoms/ValidationText';
// import listMenuChildTypes from '../../constants/MenuChildType';
import { languages, languageType } from '../../constants/Language';

const styles = theme => ({
  root: {
    position: 'absolute',
    width: '85%',
    height: 'auto',
    maxHeight: '80%',
    top: '5%',
    left: '2%',
    backgroundColor: '#fff',
    padding: 28,
    overflow: 'scroll',
    outline: 'none',
    [theme.breakpoints.down('sm')]: {
      width: '95%',
      padding: 16
    }
  },
  pageTitle: {
    margin: '20px 0px 0px',
    paddingLeft: 20,
    paddingTop: 2,
    textAlign: 'left',
    backgroundColor: '#fff',
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 0,
      marginBottom: 10
    }
  },
  mainPaper: {
    position: 'relative',
    margin: '1px 0px 10px',
    padding: '10px 26px 10px 26px',
    [theme.breakpoints.down('sm')]: {
      padding: '10px 5px'
    },
    display: 'flex',
    flexDirection: 'column'
  },
  alignEnd: {
    alignSelf: 'end'
  },
  editTable: {
    width: 'auto',
    [theme.breakpoints.down('sm')]: {
      display: 'block'
    },
    '& tr': {
      [theme.breakpoints.down('sm')]: {
        display: 'block'
      }
    }
  },
  tableCellBorderNone: {
    borderBottom: 'none',
    [theme.breakpoints.down('sm')]: {
      borderBottom: 'none',
      display: 'block',
      border: 0
    }
  },
  textField100: {
    padding: '0px 5px 0px 5px',
    width: '100px'
  },
  textField: {
    padding: '0px 5px 0px 5px',
    width: '300px',
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },
  textFieldLong: {
    padding: '0px 5px 0px 5px',
    width: '500px',
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },
  priceCalc: {
    margin: '0px 5px',
    color: '#aaa'
  },
  colLeft: {
    [theme.breakpoints.down('sm')]: {
      display: 'block',
      border: 0,
      paddingBottom: 5
    }
  },
  colRight: {
    [theme.breakpoints.down('sm')]: {
      display: 'block',
      border: 0,
      paddingTop: 0
    }
  },
  hideMobile: {
    [theme.breakpoints.down('sm')]: {
      display: 'none'
    }
  },
  width100: {
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      display: 'block',
      padding: 0
    }
  }
});

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      name: state.loginInfo.name,
      detail: state.gochiMenus.detail,
      shops: state.shops.shops,
      taxTypes: state.gochiMenus.taxTypes,
      reducedTaxMenuPrefix: state.commons.reducedTaxMenuPrefix
    }),
    dispatch => ({
      actions: bindActionCreators(
        {
          getGochiMenusEvent,
          editGochiMenuEvent,
          addGochiMenuEventImage
        },
        dispatch
      )
    })
  ),
  setPropTypes(propTypes),
  withState('openEditProgress', 'updateOpenEditProgress', false),
  withState('loading', 'updateLoading', false),
  withState('isEditSuccess', 'updateIsEditSuccess', false),
  withState('resultMessage', 'setResultMessage', ''),
  withState('menuChildType', 'setMenuChildType', 1),
  withState('groupId', 'setGroupId', 0),
  withState('groupName', 'setGroupName', ''),
  withState('prefectures', 'setPrefectures', ''),
  withState('shopId', 'setShopId', 0),
  withState('shopName', 'setShopName', ''),
  withState('menuEventId', 'setMenuEventId', 0),
  withState('menuEventName', 'setMenuEventName', ''),
  withState('menuName', 'setMenuName', ''),
  withState('menuNameError', 'setMenuNameError', ''),
  withState('price', 'setPrice', ''),
  withState('priceError', 'setPriceError', ''),
  withState('priceCalc', 'setPriceCalc', '0 (税抜 0)'),
  // withState('displayAmount', 'setDisplayAmount', 0),
  // withState('displayAmountError', 'setDisplayAmountError', ''),
  withState('premiumPercent', 'setPremiumPercent', 0),
  withState('premiumPercentError', 'setPremiumPercentError', ''),
  withState('menuLimitTotal', 'setMenuLimitTotal', 0),
  withState('description', 'setDescription', ''),
  withState('taxType', 'setTaxType', 'EXTERNAL'),
  withState('reducedTaxCheck', 'setReducedTaxCheck', false),
  withState('reducedTaxType', 'setReducedTaxType', 'UNREDUCED'),
  withState('tagStr', 'setTagStr', ''),
  withState('tags', 'setTags', null),
  withState('image', 'setImage', null),
  withState('previewImage', 'setPreviewImage', null),
  withState('updatedAt', 'setUpdatedAt', ''),
  withState('manual', 'setManual', 0),
  withState('menuCombo', 'setMenuCombo', 0),
  withState('isLanguage', 'setIsLanguage', 'ja'),
  withState('translateType', 'setTranslateType', 0),
  withState('multiLangData', 'setMultiLangData', {}),
  withState('gochimeshiFlag', 'setGochimeshiFlag', 1),
  withState('isETicket', 'setIsETicket', 1),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    },
    defaultPrice: props => () => {
      let includedTaxPrice = 0;
      let excludedTaxPrice = 0;
      // TODO DBから取得
      let tax = 0.1;
      if (props.editInput.reducedTaxCheck) {
        tax = 0.08;
      }

      if (props.editInput.price !== '') {
        if (props.editInput.taxType === 'INTERNAL') {
          const amountTemp = parseFloat(
            (props.editInput.price / (1 + tax)).toFixed(9)
          );
          const taxAmount = Math.round(amountTemp * tax);
          includedTaxPrice = props.editInput.price;
          excludedTaxPrice = props.editInput.price - taxAmount;
        } else if (props.editInput.taxType === 'DONATION') {
          includedTaxPrice = props.editInput.price;
          excludedTaxPrice = props.editInput.price;
        } else {
          includedTaxPrice =
            props.editInput.price + Math.round(props.editInput.price * tax);
          excludedTaxPrice = props.editInput.price;
        }
      }
      props.setPriceCalc(`${includedTaxPrice} (税抜 ${excludedTaxPrice})`);
    }
  }),
  lifecycle({
    componentDidMount() {
      this.props.setMenuChildType(this.props.editInput.menuChildType);
      this.props.setGroupId(this.props.editInput.groupId);
      this.props.setGroupName(this.props.editInput.groupName);
      this.props.setPrefectures(this.props.editInput.prefectures);
      this.props.setShopId(this.props.editInput.shopId);
      this.props.setShopName(this.props.editInput.shopName);
      this.props.setMenuEventId(this.props.editInput.menuEventId);
      this.props.setMenuEventName(this.props.editInput.menuEventName);
      this.props.setMenuName(this.props.editInput.menuName);
      this.props.setPrice(this.props.editInput.price);
      // this.props.setDisplayAmount(this.props.editInput.displayAmount);
      this.props.setPremiumPercent(this.props.editInput.premiumPercent);
      this.props.setMenuLimitTotal(this.props.editInput.menuLimitTotal);
      this.props.setManual(this.props.editInput.manual);
      this.props.setMenuCombo(this.props.editInput.menuCombo);
      this.props.setGochimeshiFlag(this.props.editInput.gochimeshiFlag);
      this.props.setDescription(this.props.editInput.description);
      this.props.setTaxType(this.props.editInput.taxType);
      this.props.setReducedTaxType(this.props.editInput.reducedTaxType);
      if (this.props.editInput.reducedTaxType === 'REDUCED') {
        this.props.setReducedTaxCheck(true);
      }
      this.props.setTags(this.props.editInput.tags);
      this.props.setTagStr(this.props.editInput.tagStr);
      this.props.setPreviewImage(this.props.editInput.image);
      this.props.setUpdatedAt(this.props.editInput.updatedAt);
      this.props.setIsETicket(this.props.editInput.isETicket);
      this.props.defaultPrice();

      let dataFirst = {};
      const origilData = {
        menuEventName: null,
        menuName: null,
        price: null,
        // displayAmount: null,
        premiumPercent: null,
        menuLimitTotal: null,
        description: null,
        manual: null,
        menuCombo: null,
        taxType: null,
        reducedTaxType: null,
        tags: null,
        updatedAt: null,
        image: null,
        gochimeshiFlag: null
      };
      dataFirst = origilData;
      if (this.props.editInput.manual !== 1) {
        if (this.props.editInput.otherLanguages) {
          const str = JSON.stringify(this.props.editInput.otherLanguages);
          dataFirst.otherLanguages = JSON.parse(str);
        }
        languages.forEach(item => {
          if (item.value === languageType.ORIGIN) return;
          const translatedData = dataFirst.otherLanguages.find(
            el => el.language === item.value
          );
          if (!translatedData) {
            const other = {
              translateType: 0,
              language: item.value
            };
            dataFirst.otherLanguages.push(other);
          }
        });
      } else {
        dataFirst.otherLanguages = [];
      }
      this.props.setMultiLangData(dataFirst);
    }
  })
);

const Main = enhance(
  ({
    classes,
    actions,
    checkSession,
    searchKey,
    roles,
    editInput,
    openEditConfirm,
    updateOpenEdit,
    updateOpenEditConfirm,
    openEditProgress,
    updateOpenEditProgress,
    loading,
    updateLoading,
    isEditSuccess,
    updateIsEditSuccess,
    resultMessage,
    setResultMessage,
    // menuChildType,
    // groupId,
    groupName,
    // shopId,
    // shopName,
    menuEventId,
    menuEventName,
    setMenuEventName,
    menuName,
    setMenuName,
    price,
    setPrice,
    priceCalc,
    setPriceCalc,
    // displayAmount,
    // setDisplayAmount,
    // displayAmountError,
    // setDisplayAmountError,
    premiumPercent,
    setPremiumPercent,
    premiumPercentError,
    setPremiumPercentError,
    menuLimitTotal,
    description,
    setDescription,
    taxType,
    setTaxType,
    taxTypes,
    reducedTaxCheck,
    setReducedTaxCheck,
    reducedTaxType,
    setReducedTaxType,
    tagStr,
    setTagStr,
    tags,
    setTags,
    image,
    setImage,
    previewImage,
    setPreviewImage,
    updatedAt,
    reducedTaxMenuPrefix,
    menuNameError,
    setMenuNameError,
    priceError,
    setPriceError,
    prefectures,
    manual,
    menuCombo,
    isLanguage,
    setIsLanguage,
    multiLangData,
    setMultiLangData,
    translateType,
    setTranslateType,
    gochimeshiFlag,
    setGochimeshiFlag,
    isETicket,
    setIsETicket
  }) => {
    // const editConfirm = {
    //   // menuChildType,
    //   prefectures,
    //   groupName,
    //   // shopName,
    //   menuEventName,
    //   menuName,
    //   price,
    //   displayAmount,
    //   description,
    //   manual,
    //   menuCombo,
    //   taxType,
    //   reducedTaxCheck,
    //   tagStr,
    //   previewImage
    // };
    // const editParam = {
    //   // menuChildType,
    //   // groupId,
    //   // shopId,
    //   menuEventName,
    //   menuName,
    //   price,
    //   displayAmount,
    //   description,
    //   manual,
    //   menuCombo,
    //   taxType,
    //   reducedTaxType,
    //   tags,
    //   updatedAt,
    //   image
    // };

    const errors = {
      menuNameError,
      priceError,
      // displayAmountError
      premiumPercentError
    };

    const validMenuName = () => {
      if (isLanguage !== languageType.ORIGIN && translateType === 0) {
        return 0;
      }
      const value = menuName;
      if (value.trim() === '') {
        setMenuNameError('必須項目です。');
        return 1;
      }
      setMenuNameError('');
      setMenuName(value);
      return 0;
    };
    const validPrice = () => {
      const value = price;
      if (manual === 0) {
        if (value === '') {
          setPriceError('必須項目です。');
          return 1;
        }
        if (!/^\d+$/.test(value)) {
          setPriceError('半角数字のみ入力してください。');
          return 1;
        }
      }
      setPriceError('');
      setPrice(value);
      return 0;
    };
    // const validDisplayAmount = () => {
    //   const value = displayAmount;
    //   if (value === 0) {
    //     setDisplayAmountError('必須項目です。');
    //     return 1;
    //   }
    //   if (!/^\d+$/.test(value)) {
    //     setDisplayAmountError('半角数字のみ入力してください。');
    //     return 1;
    //   }
    //   setDisplayAmountError('');
    //   setDisplayAmount(value);
    //   return 0;
    // };
    const validPremiumPercent = () => {
      const value = premiumPercent;
      if (value === '') {
        setPremiumPercentError('必須項目です。');
        return 1;
      }
      if (!/^\d+$/.test(value)) {
        setPremiumPercentError('プレミアム率を正しくご入力ください。');
        return 1;
      }
      setPremiumPercentError('');
      setPremiumPercent(value);
      return 0;
    };
    const valid = () => {
      const errorCount = validMenuName() + validPrice() + validPremiumPercent();
      if (errorCount === 0) {
        return true;
      }
      return false;
    };

    const getCurrentData = () => {
      const lang = isLanguage;
      let data = multiLangData;
      const origilParam = {
        menuEventName,
        menuName,
        price,
        // displayAmount,
        premiumPercent: Number(premiumPercent),
        menuLimitTotal,
        description,
        manual,
        menuCombo,
        taxType,
        reducedTaxType,
        tags,
        updatedAt,
        image,
        gochimeshiFlag,
        isETicket
      };
      const otherParam = {
        translateType,
        language: lang,
        params: {
          menuName,
          description,
          menuEventName
        }
      };
      // origin
      if (lang === languageType.ORIGIN) {
        data = { ...data, ...origilParam };
      } else {
        // other languages
        for (let index = 0; index < data.otherLanguages.length; index += 1) {
          if (data.otherLanguages[index].language === lang) {
            data.otherLanguages[index] = otherParam;
          }
        }
      }
      const str = JSON.stringify(data);
      return JSON.parse(str);
    };

    const cancelAction = () => updateOpenEdit(false);
    const confirmAction = () => {
      if (!valid()) {
        alert('登録情報を正しく入力してください。');
      } else {
        setMultiLangData(getCurrentData());
        updateOpenEditConfirm(true);
      }
    };
    const backAction = () => updateOpenEditConfirm(false);
    const editAction = async () => {
      updateLoading(true);
      updateOpenEditProgress(true);
      const param = {
        ...multiLangData,
        otherLanguages: multiLangData.otherLanguages
      };
      if (typeof image !== 'undefined' && image !== null) {
        let imageData = image;
        if (imageData.size > Number(process.env.REACT_APP_RESIZE_BORDER)) {
          const { resizeImageFile } = await resizeImage(imageData);
          imageData = resizeImageFile;
        }
        const imagePath = await uploadFile(
          'menu_event',
          menuEventId,
          imageData,
          'public'
        );
        actions
          .addGochiMenuEventImage(menuEventId, {
            image: imagePath
          })
          .then(data => checkSession(data));
        param.image = imagePath;
      }
      const editedMenu = await actions
        .editGochiMenuEvent(menuEventId, param)
        .then(data => checkSession(data));
      if (editedMenu.type === 'EDIT_GOCHI_MENU_EVENT_SUCCESS') {
        updateIsEditSuccess(true);
        actions.getGochiMenusEvent(searchKey).then(data => checkSession(data));
        setResultMessage('編集が完了しました。');
        updateLoading(false);
      } else {
        updateIsEditSuccess(false);
        setResultMessage('編集に失敗しました。');
        updateLoading(false);
      }
    };
    const progressOkAction = () => {
      if (isEditSuccess) {
        updateOpenEdit(false);
        updateOpenEditConfirm(false);
        updateOpenEditProgress(false);
      } else {
        updateOpenEditProgress(false);
      }
    };

    const calcPrice = e => {
      let includedTaxPrice = 0;
      let excludedTaxPrice = 0;

      let latestPrice = price;
      if (e.target.id === 'price') {
        latestPrice = e.target.value;
      }

      let latestTaxType = taxType;
      if (e.target.name === 'taxType') {
        latestTaxType = e.target.value;
      }

      // TODO DBから取得
      let tax = 0.1;
      if (
        (e.target.id !== 'reducedTax' && reducedTaxCheck) ||
        (e.target.id === 'reducedTax' && e.target.checked)
      ) {
        // TODO DBから取得
        tax = 0.08;
      }

      if (latestPrice !== '') {
        if (latestTaxType === 'INTERNAL') {
          const amountTemp = parseFloat((latestPrice / (1 + tax)).toFixed(9));
          const taxAmount = Math.round(amountTemp * tax);
          includedTaxPrice = latestPrice;
          excludedTaxPrice = latestPrice - taxAmount;
        } else if (latestTaxType === 'DONATION') {
          includedTaxPrice = latestPrice;
          excludedTaxPrice = latestPrice;
        } else {
          const taxAmount = Math.round(latestPrice * tax);
          includedTaxPrice = latestPrice * 1 + taxAmount;
          excludedTaxPrice = latestPrice;
        }
      }

      setPriceCalc(`${includedTaxPrice} (税抜 ${excludedTaxPrice})`);
    };
    const splitTagStr = str => {
      if (str === '') {
        setTags(null);
      } else {
        setTags(
          str.split(/\s+/).map(t => {
            return { tagName: t };
          })
        );
      }
    };
    const convertReducedTax = checked => {
      if (checked) {
        setReducedTaxType('REDUCED');
      } else {
        setReducedTaxType('UNREDUCED');
      }
    };

    const setLanguage = v => {
      const lang = isLanguage;
      const data = getCurrentData();
      if (
        (v !== languageType.ORIGIN && lang === languageType.ORIGIN) ||
        (v !== languageType.ORIGIN && lang !== languageType.ORIGIN)
      ) {
        // origin to other or other to other lang
        for (let k = 0; k < multiLangData.otherLanguages.length; k += 1) {
          if (multiLangData.otherLanguages[k].language === v) {
            setMenuName(
              multiLangData.otherLanguages[k].params &&
                multiLangData.otherLanguages[k].params.menuName
                ? multiLangData.otherLanguages[k].params.menuName
                : ''
            );
            setDescription(
              multiLangData.otherLanguages[k].params &&
                multiLangData.otherLanguages[k].params.description
                ? multiLangData.otherLanguages[k].params.description
                : ''
            );
            setTranslateType(
              multiLangData.otherLanguages[k].translateType
                ? multiLangData.otherLanguages[k].translateType
                : 0
            );
            setMenuEventName(
              multiLangData.otherLanguages[k].params &&
                multiLangData.otherLanguages[k].params.menuEventName
                ? multiLangData.otherLanguages[k].params.menuEventName
                : ''
            );
          }
        }
      } else if (v === languageType.ORIGIN) {
        // other to origin
        setMenuName(multiLangData.menuName);
        setDescription(multiLangData.description);
        setMenuEventName(multiLangData.menuEventName);
      }
      setIsLanguage(v);
      setMultiLangData(data);
    };

    return (
      <div className={classes.root}>
        <div className={classes.pageTitle}>
          <Typography variant="h6">メニュー編集</Typography>
        </div>
        <Paper className={classes.mainPaper} elevation={1}>
          <Select
            className={`${classes.textField} ${classes.alignEnd}`}
            value={isLanguage}
            disabled={manual === 1}
            onChange={e => {
              if (isLanguage === e.target.value) {
                return;
              }
              if (
                valid() ||
                (isLanguage !== languageType.ORIGIN && translateType === 0)
              ) {
                setLanguage(e.target.value);
              } else {
                alert('登録情報を正しく入力してください。');
              }
            }}
          >
            {languages.map(lang => (
              <MenuItem key={lang.value} value={lang.value}>
                {lang.label}
              </MenuItem>
            ))}
          </Select>
          {isLanguage !== languageType.ORIGIN && (
            <ListItem className={classes.itemForm}>
              <Typography component="div" className={classes.formInput}>
                <RadioGroup
                  value={translateType}
                  onChange={e => {
                    setTranslateType(parseInt(e.target.value, 10));
                  }}
                >
                  <FormControlLabel
                    value={0}
                    control={<Radio color="primary" />}
                    label="GG翻訳を選択"
                  />
                  <FormControlLabel
                    value={1}
                    control={<Radio color="primary" />}
                    label="自分で文章入力"
                  />
                </RadioGroup>
              </Typography>
            </ListItem>
          )}
          <Table className={classes.editTable}>
            <TableBody>
              <TableRow>
                <TableCell className={classes.colLeft}>
                  <AnyButton />
                </TableCell>
                <TableCell className={classes.colRight}>
                  <TextField
                    label="イベント名"
                    defaultValue={editInput.menuEventName}
                    className={classes.textField}
                    margin="normal"
                    onChange={e => {
                      setMenuEventName(e.target.value);
                    }}
                    value={menuEventName}
                    inputProps={{
                      maxLength: isLanguage === languageType.ORIGIN ? 250 : 1000
                    }}
                    disabled={
                      isLanguage !== languageType.ORIGIN && translateType === 0
                    }
                  />
                </TableCell>
                <TableCell className={classes.width100} />
              </TableRow>
              <TableRow>
                <TableCell className={classes.colLeft}>
                  <RequiredButton />
                </TableCell>
                <TableCell className={classes.colRight}>
                  <TextField
                    required
                    label="メニュー名"
                    defaultValue={editInput.menuName}
                    className={classes.textField}
                    margin="normal"
                    onChange={e => {
                      setMenuName(e.target.value);
                    }}
                    onBlur={validMenuName}
                    value={menuName}
                    inputProps={{
                      maxLength: isLanguage === languageType.ORIGIN ? 250 : 1000
                    }}
                    disabled={
                      isLanguage !== languageType.ORIGIN && translateType === 0
                    }
                  />
                  {(isLanguage === languageType.ORIGIN ||
                    translateType === 1) && (
                    <ValidationText message={errors.menuNameError} />
                  )}
                </TableCell>
                <TableCell className={classes.width100} />
              </TableRow>
              <TableRow>
                <TableCell className={classes.colLeft}>
                  <RequiredButton />
                </TableCell>
                <TableCell className={classes.colRight}>
                  <Typography className={classes.description}>
                    チケット発行種別
                  </Typography>
                  <RadioGroup
                    row
                    value={isETicket}
                    onChange={e => {
                      setIsETicket(parseInt(e.target.value, 10));
                    }}
                  >
                    <FormControlLabel
                      value={1}
                      control={<Radio color="primary" />}
                      label="電子"
                    />
                    <FormControlLabel
                      value={0}
                      control={<Radio color="primary" />}
                      label="紙印刷"
                    />
                  </RadioGroup>
                </TableCell>
                <TableCell className={classes.width100} />
              </TableRow>
              {isLanguage === languageType.ORIGIN && (
                <TableRow>
                  <TableCell className={classes.tableCellBorderNone}>
                    <RequiredButton />
                  </TableCell>
                  <TableCell className={classes.tableCellBorderNone}>
                    <RadioGroup value={editInput.manual}>
                      <FormControlLabel
                        disabled
                        value={editInput.manual}
                        control={<Radio color="primary" />}
                        label={
                          editInput.manual === 1
                            ? 'イベントメニューのマニュアルで挿入'
                            : 'イベントメニューの自動挿入'
                        }
                      />
                    </RadioGroup>
                  </TableCell>
                  <TableCell className={classes.tableCellBorderNone} />
                </TableRow>
              )}
              {editInput.manual === 0 && isLanguage === languageType.ORIGIN && (
                <TableRow>
                  <TableCell className={classes.tableCellBorderNone}>
                    <RequiredButton />
                  </TableCell>
                  <TableCell className={classes.tableCellBorderNone}>
                    <Typography className={classes.description}>
                      利用方法
                    </Typography>
                    <RadioGroup value={editInput.menuLimitTotal}>
                      <FormControlLabel
                        disabled
                        value={editInput.menuLimitTotal}
                        control={<Radio color="primary" />}
                        label={
                          editInput.menuLimitTotal === 1
                            ? '一円単位利用'
                            : '一枚単位利用'
                        }
                      />
                    </RadioGroup>
                  </TableCell>
                  <TableCell className={classes.tableCellBorderNone} />
                </TableRow>
              )}
              {manual === 0 && isLanguage === languageType.ORIGIN && (
                <TableRow>
                  <TableCell className={classes.colLeft}>
                    <RequiredButton />
                  </TableCell>
                  <TableCell className={classes.colRight}>
                    <TextField
                      id="price"
                      required
                      label="価格"
                      defaultValue={editInput.price}
                      className={classes.textField}
                      margin="normal"
                      onChange={e => {
                        setPrice(e.target.value);
                        calcPrice(e);
                      }}
                      onBlur={validPrice}
                    />
                    <ValidationText message={errors.priceError} />
                    <div className={classes.priceCalc}>{priceCalc}</div>
                  </TableCell>
                  <TableCell className={classes.width100} />
                </TableRow>
              )}
              {/* {isLanguage === languageType.ORIGIN && (
                <TableRow>
                  <TableCell className={classes.colLeft}>
                    <RequiredButton />
                  </TableCell>
                  <TableCell className={classes.colRight}>
                    <TextField
                      required
                      label="表示金額"
                      defaultValue={editInput.displayAmount}
                      className={classes.textField}
                      margin="normal"
                      onChange={e => {
                        setDisplayAmount(e.target.value);
                      }}
                      onBlur={validDisplayAmount}
                    />
                    <ValidationText message={errors.displayAmountError} />
                  </TableCell>
                  <TableCell className={classes.width100} />
                </TableRow>
              )} */}
              {manual === 0 && isLanguage === languageType.ORIGIN && (
                <TableRow>
                  <TableCell className={classes.colLeft}>
                    <RequiredButton />
                  </TableCell>
                  <TableCell className={classes.colRight}>
                    <div>
                      <TextField
                        id="taxType"
                        name="taxType"
                        select
                        label="税区分・寄付"
                        className={classes.textField}
                        margin="normal"
                        value={taxType}
                        onChange={e => {
                          setTaxType(e.target.value);
                          calcPrice(e);
                        }}
                        InputLabelProps={{
                          shrink: true
                        }}
                      >
                        {taxTypes.map(group => {
                          return (
                            <MenuItem key={group.id} value={group.id}>
                              {group.name}
                            </MenuItem>
                          );
                        })}
                      </TextField>
                    </div>
                    <FormControlLabel
                      control={
                        <Checkbox
                          id="reducedTax"
                          color="primary"
                          checked={reducedTaxCheck}
                        />
                      }
                      label="軽減税率対象"
                      onChange={e => {
                        setReducedTaxCheck(e.target.checked);
                        convertReducedTax(e.target.checked);
                        calcPrice(e);
                      }}
                    />
                  </TableCell>
                  <TableCell className={classes.width100} />
                </TableRow>
              )}
              {isLanguage === languageType.ORIGIN && (
                <TableRow>
                  <TableCell className={classes.colLeft}>
                    <RequiredButton />
                  </TableCell>
                  <TableCell className={classes.colRight}>
                    <TextField
                      required
                      label="プレミアム率"
                      defaultValue={editInput.premiumPercent}
                      className={classes.textField}
                      margin="normal"
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">%</InputAdornment>
                        )
                      }}
                      onChange={e => {
                        setPremiumPercent(e.target.value);
                      }}
                      onBlur={validPremiumPercent}
                    />
                    <ValidationText message={errors.premiumPercentError} />
                  </TableCell>
                  <TableCell className={classes.width100} />
                </TableRow>
              )}
              {editInput.prefectures &&
                !editInput.groupName &&
                isLanguage === languageType.ORIGIN && (
                  <TableRow>
                    <TableCell className={classes.tableCellBorderNone}>
                      <RequiredButton />
                    </TableCell>
                    <TableCell className={classes.tableCellBorderNone}>
                      <TextField
                        required
                        label="都道府県"
                        defaultValue={editInput.prefectures}
                        className={classes.textField}
                        margin="normal"
                        InputProps={{
                          readOnly: true
                        }}
                        variant="filled"
                      />
                    </TableCell>
                    <TableCell className={classes.tableCellBorderNone} />
                  </TableRow>
                )}
              {editInput.groupName &&
                !editInput.prefectures &&
                isLanguage === languageType.ORIGIN && (
                  <TableRow>
                    <TableCell className={classes.tableCellBorderNone}>
                      <RequiredButton />
                    </TableCell>
                    <TableCell className={classes.tableCellBorderNone}>
                      <TextField
                        required
                        label="グループ"
                        defaultValue={editInput.groupName}
                        className={classes.textField}
                        margin="normal"
                        InputProps={{
                          readOnly: true
                        }}
                        variant="filled"
                      />
                    </TableCell>
                    <TableCell className={classes.tableCellBorderNone} />
                  </TableRow>
                )}
              {editInput.prefectures &&
                editInput.groupName &&
                isLanguage === languageType.ORIGIN && (
                  <>
                    <TableRow>
                      <TableCell className={classes.tableCellBorderNone}>
                        <RequiredButton />
                      </TableCell>
                      <TableCell className={classes.tableCellBorderNone}>
                        <TextField
                          required
                          label="都道府県"
                          defaultValue={editInput.prefectures}
                          className={classes.textField}
                          margin="normal"
                          InputProps={{
                            readOnly: true
                          }}
                          variant="filled"
                        />
                      </TableCell>
                      <TableCell className={classes.tableCellBorderNone} />
                    </TableRow>
                    <TableRow>
                      <TableCell className={classes.tableCellBorderNone} />
                      <TableCell className={classes.tableCellBorderNone}>
                        <TextField
                          required
                          label="グループ"
                          defaultValue={editInput.groupName}
                          className={classes.textField}
                          margin="normal"
                          InputProps={{
                            readOnly: true
                          }}
                          variant="filled"
                        />
                      </TableCell>
                      <TableCell className={classes.tableCellBorderNone} />
                    </TableRow>
                  </>
                )}
              <TableRow>
                <TableCell className={classes.width100} />
                <TableCell className={classes.width100} />
                <TableCell className={classes.width100} />
              </TableRow>
              {manual === 1 && isLanguage === languageType.ORIGIN && (
                <TableRow>
                  <TableCell className={classes.tableCellBorderNone}>
                    <RequiredButton />
                  </TableCell>
                  <TableCell className={classes.tableCellBorderNone}>
                    <RadioGroup value={editInput.menuCombo}>
                      <FormControlLabel
                        disabled
                        value={editInput.menuCombo}
                        control={<Radio color="primary" />}
                        label={
                          editInput.menuCombo === 1
                            ? '回数券チケット'
                            : '回数券ではないチケット'
                        }
                      />
                    </RadioGroup>
                  </TableCell>
                  <TableCell className={classes.tableCellBorderNone} />
                </TableRow>
              )}
              {manual === 0 && isLanguage === languageType.ORIGIN && (
                <TableRow>
                  <TableCell className={classes.colLeft}>
                    <AnyButton />
                  </TableCell>
                  <TableCell className={classes.colRight}>
                    <Typography className={classes.description}>
                      適用対象
                    </Typography>
                    <RadioGroup
                      row
                      value={gochimeshiFlag}
                      onChange={e => {
                        setGochimeshiFlag(parseInt(e.target.value, 10));
                      }}
                    >
                      <FormControlLabel
                        value={1}
                        control={<Radio color="primary" />}
                        label="全ごちめしシステム"
                      />
                      <FormControlLabel
                        value={0}
                        control={<Radio color="primary" />}
                        label="本イベントだけ"
                      />
                    </RadioGroup>
                  </TableCell>
                  <TableCell className={classes.width100} />
                </TableRow>
              )}
              <TableRow>
                <TableCell className={classes.colLeft}>
                  <AnyButton />
                </TableCell>
                <TableCell className={classes.colRight}>
                  <TextField
                    label="説明"
                    multiline
                    rows="4"
                    defaultValue={editInput.description}
                    className={classes.textFieldLong}
                    margin="normal"
                    onChange={e => {
                      setDescription(e.target.value);
                    }}
                    value={description}
                    inputProps={{
                      maxLength:
                        isLanguage === languageType.ORIGIN ? 1000 : 2500
                    }}
                    disabled={
                      isLanguage !== languageType.ORIGIN && translateType === 0
                    }
                  />
                </TableCell>
                <TableCell className={classes.width100} />
              </TableRow>
              {isLanguage === languageType.ORIGIN && (
                <TableRow>
                  <TableCell className={classes.colLeft}>
                    <AnyButton />
                  </TableCell>
                  <TableCell className={classes.colRight}>
                    <TextField
                      label="タグ"
                      defaultValue={editInput.tagStr}
                      className={classes.textFieldLong}
                      margin="normal"
                      onChange={e => {
                        setTagStr(e.target.value);
                        splitTagStr(e.target.value);
                      }}
                    />
                  </TableCell>
                  <TableCell className={classes.colRight}>
                    #おすすめ #おふくろの味 #学生に ＃ガッツリ
                    などメニューの特徴を表すタグを記載できます。
                  </TableCell>
                </TableRow>
              )}
              {isLanguage === languageType.ORIGIN && (
                <TableRow>
                  <TableCell
                    className={[classes.tableCellBorderNone, classes.colLeft]}
                  >
                    <AnyButton />
                  </TableCell>
                  <TableCell
                    className={[classes.tableCellBorderNone, classes.colRight]}
                  >
                    <FileUpload
                      label="image"
                      file={image}
                      setFile={setImage}
                      previewImage={previewImage}
                      setPreviewImage={setPreviewImage}
                    />
                  </TableCell>
                  <TableCell className={classes.tableCellBorderNone} />
                </TableRow>
              )}
            </TableBody>
          </Table>
        </Paper>
        <div>
          <CancelButton onClickAction={cancelAction} color="primary" />
          <ConfirmButton onClickAction={confirmAction} />
        </div>
        <Modal open={openEditConfirm}>
          <GochiMenuEventEditConfirm
            backAction={backAction}
            editAction={editAction}
            editConfirm={multiLangData}
            roles={roles}
            reducedTaxMenuPrefix={reducedTaxMenuPrefix}
            openEditProgress={openEditProgress}
            progressOkAction={progressOkAction}
            loading={loading}
            resultMessage={resultMessage}
            currentLanguage={isLanguage}
            previewImage={previewImage}
            reducedTaxCheck={reducedTaxCheck}
            groupName={groupName}
            tagStr={tagStr}
            prefectures={prefectures}
          />
        </Modal>
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
